import { createBreakpoints } from '@chakra-ui/theme-tools';

const breakpoints = createBreakpoints({
  sm: '320px',
  md: '834px',
  lg: '1280px',
  xl: '1400px',
  '2xl': '1536px',
});

export default breakpoints;
